import { buildVarMap, extractConditionBlocks, extractFieldKeyFromSelector } from '../utils';

const HIDE_PATTERN = /\$\(\s*([^)]+?)\s*\)(?:\s*\.\w+\([^)]*\))*\s*\.hide\(\)/g;
const SHOW_PATTERN = /\$\(\s*([^)]+?)\s*\)(?:\s*\.\w+\([^)]*\))*\s*\.show\(\)/g;

function resolveTarget(receiver, varMap) {
  if (!receiver) return null;
  const trimmed = receiver.trim();
  if (/^["'].*["']$/.test(trimmed)) {
    return extractFieldKeyFromSelector(trimmed.slice(1, -1));
  }
  return varMap[trimmed] || null;
}

export function detectVisibilityPatterns(script, ownerFieldKey) {
  if (!script) return [];
  const effects = [];
  const varMap = buildVarMap(script);
  const conditionBlocks = extractConditionBlocks(script);

  conditionBlocks.forEach(({ condition, body }) => {
    const actions = [];

    let match;
    HIDE_PATTERN.lastIndex = 0;
    while ((match = HIDE_PATTERN.exec(body)) !== null) {
      const target = resolveTarget(match[1], varMap);
      if (target) actions.push({ target, action: 'hide' });
    }

    SHOW_PATTERN.lastIndex = 0;
    while ((match = SHOW_PATTERN.exec(body)) !== null) {
      const target = resolveTarget(match[1], varMap);
      if (target) actions.push({ target, action: 'show' });
    }

    if (actions.length > 0) {
      effects.push({ when: condition, actions });
    }
  });

  return effects;
}
